import React from 'react'
import { connect } from 'react-redux';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import $ from 'jquery'

import ViewQuote from './ViewQuote'

import { clearNoDataError } from '../../GlobalStateContainer/actions'

import {
    fetchQuote,
    fetchQuoteError,
    errorQuote,
    fetchQuotesList
} from './actions'

import CommError from '../../Shared/Errors/Errors'
import ConfirmModal from '../../Shared/ConfirmModal/ConfirmModal'

import './Quotes.css'

var Spinner = require('react-spinkit');

let chkReturn = 0;

class Quotes extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            nameSrch: '',
            viewQuoteMode: false,
        };

        this.fetchQuoteErrorClear = this.fetchQuoteErrorClear.bind(this);
        this.errorQuoteClear = this.errorQuoteClear.bind(this);
        this.errorNoDataClear = this.errorNoDataClear.bind(this);

        this.search = this.search.bind(this);

        this.quoteView = this.quoteView.bind(this);
        this.quoteViewVerify = this.quoteViewVerify.bind(this);
        this.cancelQuote = this.cancelQuote.bind(this);
     }

    fetchQuoteErrorClear() {
        this.props.dispatch(fetchQuoteError);
    }

    errorQuoteClear(e) {
        this.props.dispatch(errorQuote);

        if (this.props.quote.error === "409") {
            let id = e.target.attributes.quote.value;

            fetchQuote.bind(this)(id);
        }
    }

    errorNoDataClear() {
        this.props.dispatch(clearNoDataError);
    }

    search(e) {
        this.setState({ nameSrch: e.target.value.toLowerCase() })
    }

    quoteView(e) {

        if (chkReturn || this.props.quotes.fetching) return;
        chkReturn = 1;

        let id = e.target.attributes.quote.value;

        fetchQuote.bind(this)(id);

        chkReturn = setInterval(this.quoteViewVerify, 100);
    }
    quoteViewVerify() {
        if (this.props.quote.fetched || this.props.quote.error) {
            if (this.props.quote.fetched) {
                this.setState({
                    viewQuoteMode: true
                });

                $('.navbar-static-top').css('z-index', 0);
            }

            clearInterval(chkReturn);
            chkReturn = 0;
        }
    }
    cancelQuote() {
        this.props.dispatch(errorQuote);

        this.setState({
            viewQuoteMode: false
        });

        $('.navbar-static-top').css('z-index', 1000);
    }

    render() {
        return (
            <div className="product-quotes col-xs-12">
                <CommError error={this.props.quote.error} onClose={this.errorQuoteClear} />
                <CommError error={this.props.quotes.error} onClose={this.fetchQuoteErrorClear} />

                <ConfirmModal open={this.props.quotes.noData} heading={"Quotes Requested"} msg={"No Records"} notifyOnly={true} onYes={this.errorNoDataClear} />

                <div className="headWrapper">
                    <div className="productQuotes">
                        <h1>Quotes Requested</h1>
                    </div>
                </div>

                <div id="srch">
                    <span>Search by Name:</span>
                    {
                        this.props.quotes.fetching ?
                            <input id="name" disabled />
                        :
                            <input id="name" autocomplete="off" spellcheck="false" onChange={this.search} />
                    }
                </div>

                <div className="tableWrapper"> 
                    {
                        this.props.quotes.fetching ?
                            <Spinner name='line-spin-fade-loader' />
                        :
                            null
                    }
                    <table className="lists table table-striped">
                        <thead>
                            <tr className="head">
                                <th>Request Number</th>
                                <th>Date</th>
                                <th>Customer Number</th>
                                <th>Customer Name</th>
                                <th>PO Number</th>
                                <th>Ordered By</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                this.props.quotesList ?
                                    this.props.quotesList.filter((quote) => {
                                        if (this.state.nameSrch.length) {
                                            if (quote.customerName.toLowerCase().startsWith(this.state.nameSrch)) {
                                                quote.prefix = quote.customerName.substring(0, this.state.nameSrch.length)
                                                quote.suffix = quote.customerName.substring(this.state.nameSrch.length)

                                                return true
                                            }
                                            else return false
                                        }
                                        else return true
                                    }).map((quote, index) => {
                                        return <tr className="body" key={index}>
                                            <td className="name" quote={quote.id} onClick={this.quoteView}>{quote.id}</td>
                                            <td>{quote.createdDateDisplay}</td>
                                            <td>{quote.customerNumber}</td>
                                            <td>
                                                {this.state.nameSrch.length ? <p><span className="srch">{quote.prefix}</span><span>{quote.suffix}</span></p> : quote.customerName}
                                            </td>
                                            <td>{quote.poNumber}</td>
                                            <td>{quote.orderedBy}</td>
                                        </tr>
                                    })  : null
                            }
                        </tbody>
                    </table>
                </div>

                {
                    this.props.quote.fetched ?
                        <ViewQuote
                            errQuote={this.props.quote}
                            errQuoteClear={this.errorQuoteClear}

                            curQuote={this.props.quote.quote}

                            isOpen={this.state.viewQuoteMode}

                            onRequestCancel={this.cancelQuote}
                        />
                    : null
                }
            </div>
        );
    }
}

const mapStateToProps = state => ({
    quote: state.quote,
    quotes: state.quotes
});

export default connect(mapStateToProps)(Quotes)